import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import env from '@lib/env';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: env.API_BASE_URL,
    prepareHeaders: (headers) => {
      // Skip ngrok browser warning page
      headers.set('ngrok-skip-browser-warning', '69420'); // Use common trick value

      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Reservation', 'Service', 'Slot', 'User'],
  endpoints: () => ({}),
});
